/**
 * Lightweight GA4 event helper. Safe to call even before GA4 loads —
 * the buffer will drain once gtag() becomes available. If GA4 is never
 * configured (no REACT_APP_GA4_ID env), all calls are silent no-ops.
 */

function gtagSafe(...args) {
  try {
    if (typeof window === 'undefined') return;
    // gtag pushes to window.dataLayer, which is created by ensureGa4() in SeoHead
    if (typeof window.gtag === 'function') {
      window.gtag(...args);
    } else if (Array.isArray(window.dataLayer)) {
      // gtag not yet defined but dataLayer is — direct push works
      window.dataLayer.push(args);
    }
  } catch { /* noop */ }
}

/** Fire a GA4 event. Extra params are passed through. */
export function trackEvent(eventName, params = {}) {
  gtagSafe('event', eventName, params);
}

/** Convenience — flag a form submission as a GA4 conversion candidate. */
export function trackConversion(name, value = 0, currency = 'USD', extra = {}) {
  gtagSafe('event', name, { value, currency, ...extra });
}
